import React, { FC } from 'react'
import { Modal } from '../../../components/common/Modal/Modal'
import { ModalHeader } from '../../../components/common/Modal/ModalHeader';
import { ModalBody } from '../../../components/common/Modal/ModalBody';
import { CustomSearchProducts } from '../../../components/common/CustomSearchProducts/CustomSearchProducts';

const SearchProductModal: FC<any> = (props): JSX.Element | any => {
    const { open, closeModal, productsSelected, setProductsSelected, clearState } = props;
    return (
        <>
            <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{ style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' } }}>
                <ModalHeader
                    text={'Seleccionar productos'}
                    className='positionElements'
                    onCancel={closeModal}
                    clearState={clearState}
                />
                <ModalBody>
                    <CustomSearchProducts />
                </ModalBody>
            </Modal>
        </>
    )
}

export default SearchProductModal